import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { Button, Form, Row, Col } from "react-bootstrap";
import { Eye, EyeOff } from "lucide-react";
import Divider from "../common/Divider";
import SocialAuthButtons from "./SocialAuthButtons";
import {
  EmailValidation,
  PasswordValidation,
} from "../../util/input-validation.js";
import { loginUser, loginStatusCheck } from "../../api/authentication";
import { saveUserCredentials } from "../../redux/actions/user";
import { setUserSubscription, createOrderIdAction, startUserTrial } from "../../redux/actions/packageAction";
import {
    getBrokerList, 
} from "../../redux/actions/brokerAction";
import {deleteCookieCredentials , getLocalStorageObject, setLocalStorageObject, setCookieCredentials as setUserLocalCreds, removeKeyLocalStorageObject} from '../../util/helper';
import bg18 from '../../assets//img/hero/offer-2.webp';
import Modal from 'react-bootstrap/Modal';
import { useGoogleLogin } from '@react-oauth/google';
import { useToast } from "components/common/custom-toast/Toast";
const axios = require('axios').default;
let localStorageObj = getLocalStorageObject("user") || 
  {
    "userID": "",
    "userType": "",
    "email": "",
    "loginSecret": "",
    "activeSubscription": false,
    "activeTradeSubscription": false,
    "gUserRegisterRequired": false,
    "subscriptionValidTill": "",
    "trialAllowed": false,
    "tradeTrailAllowed": false,
    "webSocketChannel": "",
    "tradeSubscriptionValidTill": "",
    "src": "quiktrade",
    "isLoggedIn": true,
    "brokerLoggedIn":false
}

const LoginForm = ({ hasLabel, layout }) => {
  const navigate = useNavigate();
  const packageReducer = useSelector((state) => state.packageReducer);
  const dispatch = useDispatch();
  const initial = {
    email: "",
    password: "",
    remember: false,
    gtoken :""
  };
  const [formData, setFormData] = useState(initial);
  const [errorText, setErrorText] = useState(initial);
  const [showErrorText, setShowErrorText] = useState(false);
  const [requestError, setRequestError] = useState();
  const [showModal, setShowModal] = useState(false);
  const [readyForPayment, setReadyForPayment] = useState(false);
  const [promoCode, setPromocode] = useState("");
  const [selectedPlan, setselectedPlan] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const toast = useToast()

  useEffect(() => {
    let emailStatus = EmailValidation(formData.email);
    let passwordStatus = PasswordValidation(formData.password);

    let error = {
      email: emailStatus ? "" : "Enter a valid Email address",
      password: passwordStatus ? "" : "Enter a valid Password",
    };

    setErrorText(error);
    setShowErrorText(false);
    setRequestError("");
  }, [formData]);

  useEffect(() => {
    const fnotraderUserId = sessionStorage.getItem("fnotraderUserid");
    const fnotraderSecret = sessionStorage.getItem("fnotraderSecret");
    if (fnotraderUserId && fnotraderSecret) {
      loginCheckForFNOTraderData(fnotraderUserId, fnotraderSecret);
    }
  }, []);

  // useEffect(() => {
  //   if (packageReducer.suscriptionOrderId) {
  //     if (readyForPayment) {
  //       setReadyForPayment(false);
  //       navigate("/payment",{selectedPlan:selectedPlan,promoCode:promoCode});
  //     }
  //   }
  // }, [packageReducer.suscriptionOrderId]);

  const clearData = () => {
    setFormData(initial);
  };

  const setCookieCredentialsCookie = (loginSecret, userID) => {
    deleteCookieCredentials();
    document.cookie = "loginSecret=" + loginSecret;
    document.cookie = "userID=" + userID;
  };

  const loginCheckForFNOTraderData = async (fnotraderUserId, fnotraderSecret) => {
    const data = await loginStatusCheck(fnotraderUserId, fnotraderSecret);
    if (data?.code === 200) {
      setCookieCredentialsCookie(fnotraderSecret, fnotraderUserId);
      dispatch(saveUserCredentials({ ...data?.data, isLoggedIn: true }));
      navigate("/home");
    } else if (data?.error) {
      toast.error("Invalid login credentials. Please re-login.");
      navigate("/authentication/login");
    } else {
      setRequestError("Please check your internet connection and try again");
    }
  }; 

  // Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    // toast.success(`Logged in as ${formData.email}`);
    if (!errorText.email && !errorText.password) {
      const data = await loginUser(formData);

      if (data?.code === 200) {
        const { AlgoSignals, Terminal, Trial, Unlimited, tradeSubscriptionValidTill } = data?.data;
        const hasActiveSubscription = AlgoSignals?.activeTradeSubscription ||
          Terminal?.activeTradeSubscription ||
          Trial?.activeTradeSubscription ||
          Unlimited?.activeTradeSubscription;

        setUserLocalCreds({ ...data?.data, isLoggedIn: true }, localStorageObj);
        dispatch(saveUserCredentials({ ...data?.data, isLoggedIn: true }));
        clearData();

        setTimeout(async () => {
          const brokerData = await dispatch(getBrokerList('loggedIn'));
          const hasQuickTrade = brokerData?.brokers?.some(b => b.quickTrade && b.status === "loggedIn");
          if (hasQuickTrade) {
            dispatch(saveUserCredentials({ ...data?.data, isLoggedIn: true, brokerLoggedIn: true }));
            setLocalStorageObject('user', 'brokerLoggedIn', true, localStorageObj);
          } else {
            dispatch(saveUserCredentials({ ...data?.data, isLoggedIn: true, brokerLoggedIn: false }));
            setLocalStorageObject('user', 'brokerLoggedIn', false, localStorageObj);
          }
        }, 1000);

        if (hasActiveSubscription) {
          dispatch(setUserSubscription(tradeSubscriptionValidTill));
          navigate("/home");
        } else {
          navigate("/pricing");
        }

      } else if (data?.error) {
        setRequestError(data?.error);
      } else {
        setRequestError("Please check your internet connection and try again");
      }
    } else {
      setShowErrorText(true);
    }
  };

  const loginWithGoogle = useGoogleLogin({
    onSuccess: async  tokenResponse => {
      initial.gtoken = tokenResponse.access_token;
      const data = await loginUser(initial);
      if (data?.code === 200) {
        const {gUserRegisterRequired, loginSecret, email, userID, webSocketChannel,subscriptionValidTill,activeSubscription,activeTradeSubscription, brokerLoggedIn} = data?.data;

        if(!gUserRegisterRequired){
          setUserLocalCreds({...data?.data, isLoggedIn: true}, localStorageObj);
          clearData();
          dispatch(saveUserCredentials({...data?.data, isLoggedIn: true}));
          setTimeout(async () => {
            const brokerData =  await  dispatch(getBrokerList('loggedIn'));
            const hasQuickTrade = brokerData?.brokers?.some(b => b.quickTrade && b.status === "loggedIn");
            if(hasQuickTrade) {
              dispatch(saveUserCredentials({...data?.data, isLoggedIn: true,brokerLoggedIn:true}));
             // document.cookie= "brokerLoggedIn=" + true;
              setLocalStorageObject('user', 'brokerLoggedIn', true, localStorageObj);

            } else {
              dispatch(saveUserCredentials({...data?.data, isLoggedIn: true,brokerLoggedIn:false}));
              //document.cookie= "brokerLoggedIn=" + false;
              setLocalStorageObject('user', 'brokerLoggedIn', false, localStorageObj);

            }
          }, 1000)
          //dispatch(saveUserCredentials({...data?.data, isLoggedIn: true,brokerLoggedIn:brokerLoggedIn}));
          if(activeTradeSubscription) {
              dispatch(setUserSubscription(data.tradeSubscriptionValidTill));
              navigate("/home");
         } else {
          navigate("/pricing");
         }
        }else{
          navigate("/authentication/register", { state: data?.data });
        }
      } else if (data?.error) {
        setRequestError(data?.error);
      } else {
        setRequestError("Please check your internet connection and try again");
      }
     
    },
    onError: error => console.log(error),
    //flow: 'auth-code',
  });

  const handleFieldChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
   const closeBrokerAlert = (e) => {
        e.preventDefault();
       setShowModal(false);
        
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label style={{marginBottom: "0.5rem"}}>Email address</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? "Email address" : ""}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="email"
          style={{fontSize: "1rem"}}
        />
        {showErrorText && (
          <p
            className="text-danger"
            style={{ fontSize: "12px", paddingTop: "4px" }}
          >
            {errorText.email}
          </p>
        )}
      </Form.Group>

      <Form.Group className="mb-3" style={{position: "relative"}}>
        {hasLabel && <Form.Label style={{marginBottom: "0.5rem"}}>Password</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? "Password" : ""}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type={showPassword ? "text" : "password"}
          style={{fontSize: "1rem", paddingRight: "2.5rem"}}
        />
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="hide-password"
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
        {showErrorText && (
          <p
            className="text-danger"
            style={{ fontSize: "12px", paddingTop: "4px" }}
          >
            {errorText.password}
          </p>
        )}
      </Form.Group>

      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <Form.Check type="checkbox" id="rememberMe" className="d-none">
            <Form.Check.Input
              type="checkbox"
              name="remember"
              checked={formData.remember}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  remember: e.target.checked,
                })
              }
            />
            <Form.Check.Label className="ms-2 mb-0 d-none">
              Remember Me
            </Form.Check.Label>
          </Form.Check>
        </Col>

        <Col xs="auto">
          <Link
            className="fs--1 mb-0"
            to={`/authentication/forgot-password`}
          >
            Forgot Password?
          </Link>
        </Col>
      </Row>

      <Form.Group>
        {requestError && (
          <p style={{ color: 'red', fontSize: "12px",textTransform:"capitalize" }}>
              * {requestError}{' '}
          </p>
        )}
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.email || !formData.password}
        >
         Login
        </Button>
      </Form.Group>
       <Divider className="mt-4">or</Divider>
       <SocialAuthButtons loginWithGoogle={loginWithGoogle}/>

       <Row className="h-100 g-0">
        <Col md={12} xs={12} sm={12}   >
          <p   className="fs--1 text-600 mb-0 mt-4 text-center">
            By proceeding, you agree to the <Link to="/terms-condition">terms and conditions</Link>
          </p>
        </Col>  
      </Row>
     
      <Row className="h-100 g-0">
        <Col md={12} xs={12} sm={12}  className="d-block d-sm-none">
          <p   className="fs--1 text-600 mb-0 mt-2 text-center">
            Not have an account? <Link to="/authentication/register">Signup here</Link>
          </p>
        </Col>  
      </Row>
    </Form>
    <Modal size="lg" show={showModal} className="offerModal"  aria-labelledby="contained-modal-title-vcenter" centered>   
        <div className="offer-close-wrap">
          <Button className="closeWindow"  onClick={closeBrokerAlert}>
             X
          </Button>
        </div>
        
        <div className="offer-image">
            <img src={bg18} />
        </div>        
            
            
    </Modal>
    </>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool,
};

LoginForm.defaultProps = {
  layout: "simple",
  hasLabel: false,
};

export default LoginForm;